import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  textAreaEdit: {
    width: '100%',
    '& > div > textArea': {
      minHeight: 190,
      color: theme.palette.primary.main
    }
  },
  altSection: {
    [theme.breakpoints.up('lg')]: {
      width: 350,
      margin: '0 auto'
    }
  }
}))
